module.exports = __webpack_public_path__ + "static/slackhtml-acd4ff3ca27a304bca411bf6d28c169e.png";